import { GcsFile } from '@aid/shared/types/classes';

export class OrganizationLogo extends GcsFile {
  url?: string;
  file?: File;
}
